import { Component, OnInit } from '@angular/core';
import {NavController} from '@ionic/angular';
import {ApiService} from '../services/api.service';

@Component({
  selector: 'app-default',
  templateUrl: './default.page.html',
  styleUrls: ['./default.page.scss'],
})
export class DefaultPage implements OnInit {

  constructor(private navController: NavController, private apiService: ApiService) {
    this.apiService.authApi.getToken().then(res => {
      if (res){
        this.navController.navigateRoot('/home');
      }
    });
  }

  goTo(uri){
    this.navController.navigateForward(uri);
  }

  ngOnInit() {
  }

}
